import React from 'react';
import { PartyBarData } from './partybar.types';

const SPECIAL_CASES = [
  {
    example: 'match GRÜNE in Grüne und Junge Grüne',
    condition: (list: PartyBarData) => {
      return list.title.toLowerCase().includes(list.shortTitle.toLowerCase());
    },
    transformation: (list: PartyBarData) => {
      const indexOfShortTitle = list.title
        .toLowerCase()
        .indexOf(list.shortTitle.toLowerCase());
      const lengthOfShortTitle = list.shortTitle.length;
      const shortTitle = list.title.slice(
        indexOfShortTitle,
        indexOfShortTitle + lengthOfShortTitle,
      );
      const indexOfShortTitleEnd = indexOfShortTitle + lengthOfShortTitle;
      const firstPart = list.title.slice(0, indexOfShortTitle); // usually empty string since short title is at the beginning
      const secondPart = list.title.slice(indexOfShortTitleEnd);

      return (
        <div className="partybar__party">
          {firstPart}
          <strong>{shortTitle}</strong>
          {secondPart}
        </div>
      );
    },
  },
  {
    example:
      'match MASSVOLL in MASS-VOLL! Bewegung für Freiheit, Souveränität & Grundrechte',
    condition: (list: PartyBarData) => {
      return list.title
        .replace(/-/g, '')
        .toLowerCase()
        .includes(list.shortTitle.toLowerCase());
    },
    transformation: (list: PartyBarData) => {
      let shortTitleInTitle: string;
      let indexOfShortTitle: number;
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < list.shortTitle.length; i++) {
        const shortTitleWithExtraChar = `${list.shortTitle
          .slice(0, i)
          .toLowerCase()}-${list.shortTitle.slice(i).toLowerCase()}`;
        if (list.title.toLowerCase().includes(shortTitleWithExtraChar)) {
          indexOfShortTitle = list.title.toLowerCase().indexOf(shortTitleWithExtraChar);
          shortTitleInTitle = list.title.slice(
            indexOfShortTitle,
            indexOfShortTitle + shortTitleWithExtraChar.length,
          );
          break;
        }
      }
      const firstPart = list.title.slice(0, indexOfShortTitle);
      const secondPart = list.title.slice(indexOfShortTitle + shortTitleInTitle.length);
      return (
        <div className="partybar__party">
          {firstPart}
          <strong>{shortTitleInTitle}</strong>
          {secondPart}
        </div>
      );
    },
  },
  {
    example: 'fallback',
    condition: () => true,
    transformation: (list: PartyBarData) => (
      <div className="partybar__party">{list.title}</div>
    ),
  },
];

const getSpecialCaseParty = (list: PartyBarData) => {
  const specialCase = SPECIAL_CASES.find((sCase) => sCase.condition(list));
  return specialCase.transformation(list);
};

export default getSpecialCaseParty;
